import { TabTitleState } from "../../../types";

export const SET_TITLE = "SET_TITLE";

export interface SetTitleAction {
  type: typeof SET_TITLE;
  payload: TabTitleState;
}
